import {RouterProps} from "../../../RouterProps";
import {useParams} from "react-router-dom";
import {useBooleanPair, useStatePair} from "react-type-extension";
import {
    AssetStarChargeValueObject
} from "../../../../data/value-object/asset/AssetStarChargeValueObject";
import {useEffect} from "react";
import {AssetStarChargeIO} from "../../../../io/AssetIO";
import {Body1, Spinner} from "@fluentui/react-components";
import {DetailDefaultPanel, DetailDefaultTab} from "../../../DetailViews";
import {
    AssetStarChargeDescription
} from "../../../../data/description/asset/AssetStarChargeDescription";
import {AssetStarChargeDomain} from "../../../../data/domain/asset/AssetStarChargeDomain";
import {AssetStarChargeDescriptor} from "../../../../data/descriptor/asset/AssetStarChargeDescriptor";

export default function Detail(props: RouterProps) {
    const params = useParams<{ assetStarChargeId: string }>()
    const item = useStatePair<AssetStarChargeValueObject | undefined>(undefined)

    useEffect(() => {
        if (item.value === undefined && params.assetStarChargeId !== undefined) {
            AssetStarChargeIO
                .getById(BigInt(params.assetStarChargeId))
                .then(item.setter)
                .catch(reason => {
                    console.error(reason)
                    alert('오류가 발생했습니다.')
                })
        }
    }, []);

    return <>
        {item.value === undefined && <Spinner />}
        {item.value !== undefined && <Page {...props} item={item.value} /> }
    </>
}

type PageProps = RouterProps & {
    item: AssetStarChargeValueObject
}

function Page(props: PageProps) {
    return <>
        <div className={props.styles.row16}>
            <DetailDefaultTab {...props} />
            <DetailDefaultPanel
                {...props}
                client={AssetStarChargeIO}
                description={AssetStarChargeDescription}
                properties={props => <PropertyBody {...props} />}/>
        </div>
    </>
}

type PropertyBodyProps = PageProps & {
    itemKey: keyof AssetStarChargeDomain
}

function PropertyBody(props: PropertyBodyProps) {
    switch (props.itemKey) {
        case "id":
        case "scheduledAt":
        case "createdAt":
            return <Body1>{AssetStarChargeDescriptor[props.itemKey](props.item)}</Body1>
        case "userId":
            return <a href={`/users/${props.item.userId}`}><Body1>{AssetStarChargeDescriptor[props.itemKey](props.item)}</Body1></a>
    }
}